import { render, staticRenderFns } from "./verifyWindow.vue?vue&type=template&id=4796ff08&scoped=true&"
import script from "./verifyWindow.vue?vue&type=script&lang=js&"
export * from "./verifyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796ff08",
  null
  
)

export default component.exports